





















import Vue from 'vue'
import { Component, Watch, Prop, Emit } from 'vue-property-decorator';
import { DxSelectBox } from 'devextreme-vue';
import { DxLoadIndicator } from 'devextreme-vue/load-indicator'
import { FilingTypeDto, ChangeFilingTypeDto } from '@/models/FilingTypeDto'
import { FilingTypeService } from '@/service/FilingTypeService'
import { MatterWorkMatterDto } from '../models/matter-work/MatterWorkMatterDto';

@Component({
    components: {
        DxSelectBox,
        DxLoadIndicator
  }
})
export default class FilingType extends Vue {

    @Prop({ required: true })
    filingTypes!: FilingTypeDto[];

    @Prop()
    matter!: MatterWorkMatterDto;

    private filingTypeService: FilingTypeService;
    private showLoad: boolean = false;
    private showCheck: boolean = false;

    get filingTypeValue () {
        return this.matter.FilingTypeId;
    }

    private debounceTime: any;

    constructor() {
        super();
        this.filingTypeService = new FilingTypeService();
    }

    private onSelection(event: any) {
        if(this.debounceTime){
            clearTimeout(this.debounceTime);
        }
        if(event.value != this.filingTypeValue) {
            
            let matterId: string = this.matter.MatterId;
            this.debounceTime = setTimeout(() => {
                this.showLoad = true;
                let dto: ChangeFilingTypeDto = new ChangeFilingTypeDto(event.value,matterId);
                this.filingTypeService.changeType(dto)
                    .then(result => {
                        this.showCheck = true;
                        this.update(dto);
                    })
                    .catch(error => {
                        console.error(error);
                    })
                    .finally(() => {
                        setTimeout(() => { 
                            this.showLoad=false;
                            this.showCheck = false;    
                        },1000);
                    });
            }, 500);
        }
    }

    @Emit()
    update(dto: ChangeFilingTypeDto) {
        return dto;
    }
}
